// externals
import type { Reducer } from 'redux';

import { initActionTypes } from '@makemydeal/dr-shared-store';
import { FETCH_USER_PROFILE_SUCCESS } from '../actionTypes/userProfileActionTypes';
import type { DealValidationState } from '../types/dealValidationTypes';

const { INIT_PENCIL_SUCCESS, INIT_PENCIL_INVALID_DEAL } = initActionTypes;

const InitialState = {};
export type DealValidationReducer = Reducer<DealValidationState>;

export const reducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS:
        case INIT_PENCIL_INVALID_DEAL: {
            const { dealValidation } = action.payload;

            // Scopes that were not validated (e.g. non-primary scenarios initialized without a
            // validation result) carry no dealValidation in their init payload. Returning the
            // existing state avoids producing a populated object that is missing the `valid` flag,
            // which would otherwise be treated as an invalid deal and trigger unwanted navigation
            // to the Open Deal screen when that scope becomes the primary deal.
            if (!dealValidation) {
                return state;
            }

            const incompleteDealDetails = action.payload.offer.incompleteDealDetails || {};
            return {
                ...state,
                ...dealValidation,
                missingDealership: incompleteDealDetails.missingDealership,
                missingVehicleData: incompleteDealDetails.missingVehicleData,
                commonOrgId: action.payload.offer.commonOrgId
            };
        }
        case FETCH_USER_PROFILE_SUCCESS: {
            return {
                ...state,
                isEmployee: action.payload.isEmployee
            };
        }
        default: {
            return state;
        }
    }
};
